import wixAnimations from 'wix-animations';

$w.onReady(function () {
	wixAnimations.timeline({ repeat: -1})
		.add($w('#vectorImage5'),  { rotate: 360, duration: 5000, easing: 'easeLinear' })
		.play();
});